import { useState } from 'react'
import { useUpdateEmailPreferenceMutation } from '@sevenrooms/api'
import { useLocales } from '@sevenrooms/locales'
import { Button } from '@sevenrooms/ui-kit/form'
import { Box, ModalHeader, Popover, VStack, notify } from '@sevenrooms/ui-kit/layout'
import { Header } from '@sevenrooms/ui-kit/typography'
import { useVenue } from '../../../hooks'
import { reservationWidgetMessages } from '../../../reservationWidgetMessages'

export interface MarketingOptInModalProps {
  isMobile: boolean
  brandColor?: string
  clientId?: string
}

export function MarketingOptInModal({ isMobile, brandColor, clientId }: MarketingOptInModalProps) {
  const { formatMessage } = useLocales()
  const venue = useVenue()
  const [showModal, setShowModal] = useState(!!clientId)
  const [updateEmailPreference, { isLoading }] = useUpdateEmailPreferenceMutation()

  const onSubscribe = async () => {
    if (!clientId) {
      return
    }
    try {
      await updateEmailPreference({
        clientId,
        venueId: venue.id,
        venueOptIns: [venue.id],
        venueOptOuts: [],
        sendDoubleOptInEmail: true,
        campaignId: '',
      })
      setShowModal(false)
      notify({
        content: formatMessage(reservationWidgetMessages.emailSubscriptionConfirmationHeader),
        type: 'success',
        autoClose: 3000,
        position: 'bottom-right',
      })
    } catch {
      notify({
        content: formatMessage(reservationWidgetMessages.resWidgetReservationHoldDefaultErrorMessage),
        type: 'error',
        autoClose: 3000,
        position: 'bottom-right',
      })
    }
  }

  return (
    <Popover
      initiallyShow
      show={showModal}
      alignment="bottom"
      shouldCloseOnBodyClick
      targetOffset={isMobile ? 0 : undefined}
      bodyOffset={isMobile ? 0 : 25}
      content={
        isMobile ? (
          <Box width="100vw" backgroundColor="secondaryBackground" pb="m" boxShadow="primaryUp">
            <VStack alignItems="center" flexGrow={1}>
              <ModalHeader onClose={() => setShowModal(false)} backgroundColor="secondaryBackground">
                <Header type="h3">{formatMessage(reservationWidgetMessages.resWidgetCheckoutVenueOptIn, { venue: venue.name })}</Header>
              </ModalHeader>
              <Button
                variant="primary"
                color={brandColor}
                data-test="marketing-subscribe-button"
                onClick={onSubscribe}
                disabled={isLoading}
              >
                <VStack width="215px" alignItems="center">
                  {formatMessage(reservationWidgetMessages.subscriptionLinkConfirmationEmailText)}
                </VStack>
              </Button>
            </VStack>
          </Box>
        ) : (
          <Box borderRadius="s" boxShadow="tertiary" pb="lm" backgroundColor="primaryBackground">
            <VStack alignItems="center" flexGrow={1}>
              <ModalHeader onClose={() => setShowModal(false)}>
                <Header type="h3" textAlign="center">
                  {formatMessage(reservationWidgetMessages.resWidgetCheckoutVenueOptIn, { venue: venue.name })}
                </Header>
              </ModalHeader>
              <Button
                variant="primary"
                color={brandColor}
                data-test="marketing-subscribe-button"
                onClick={onSubscribe}
                disabled={isLoading}
              >
                <VStack alignItems="center">{formatMessage(reservationWidgetMessages.subscriptionLinkConfirmationEmailText)}</VStack>
              </Button>
            </VStack>
          </Box>
        )
      }
    >
      <Box />
    </Popover>
  )
}
